import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import amber from '@material-ui/core/colors/amber';

import AddIcon from '@material-ui/icons/Add';

import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

import {
  Filter,
  FilterButton,
  FilterDivider,
  FilterItem,
} from 'components/core/Filter';

import { startAddBid } from '../../../store/actions/bids';
import { startEditAdmin } from '../../../store/actions/admin';
import { startEditBidListFilter } from '../../../store/actions/filters';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  addButton: {
    backgroundColor: amber[500],
    color: "#fff",
    marginLeft: theme.spacing.unit*4,
  },
  helpOverlay: {
    zIndex: theme.zIndex.overlay + 1,
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
  }
});

const BidsFilter = ({ classes, help, bidListFilter, startAddBid, startEditAdmin, startEditBidListFilter }) => {
  return(
    <div className={classes.root}>
      <Filter>
        <FilterItem>
          <FilterButton
            selected={bidListFilter.type === "all"}
            onClick={() => startEditBidListFilter({type: "all"})}
          >
            All
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Filter">
          <FilterButton
            selected={bidListFilter.type === "draft"}
            onClick={() => startEditBidListFilter({type: "draft"})}>
            Draft
          </FilterButton>
          <FilterButton
            selected={bidListFilter.type === "sent"}
            onClick={() => startEditBidListFilter({type: "sent"})}>
            Sent
          </FilterButton>
          <FilterButton
            selected={bidListFilter.type === "won"}
            onClick={() => startEditBidListFilter({type: "won"})}>
            Won
          </FilterButton>
          <FilterButton
            selected={bidListFilter.type === "lost"}
            onClick={() => startEditBidListFilter({type: "lost"})}>
            Lost
          </FilterButton>
          <FilterButton
            selected={bidListFilter.type === "cancelled"}
            onClick={() => startEditBidListFilter({type: "cancelled"})}>
            Cancelled
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Sort">
          <FilterButton
            selected={bidListFilter.orderBy === "date"}
            onClick={() => {
              let direction = "desc";
              if (bidListFilter.orderBy === "date") {
                direction = bidListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditBidListFilter({orderBy: "date", direction: direction})
            }}>
            Date
          </FilterButton>
          <FilterButton
            selected={bidListFilter.orderBy === "client"}
            onClick={() => {
              let direction = "asc";
              if (bidListFilter.orderBy === "client") {
                direction = bidListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditBidListFilter({orderBy: "client", direction: direction})
            }}>
            Client
          </FilterButton>
          <FilterButton
            selected={bidListFilter.orderBy === "bid"}
            onClick={() => {
              let direction = "desc";
              if (bidListFilter.orderBy === "bid") {
                direction = bidListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditBidListFilter({orderBy: "bid", direction: direction})
            }}>
            Bid
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem hideCaption>
          <FormControlLabel
            className={classes.optional}
            control={
              <Switch
                color="primary"
                checked={bidListFilter.showArchived}
                onChange={() => {
                  startEditBidListFilter({showArchived: !bidListFilter.showArchived})
                }}
              />
            }
            label="SHOW ARCHIVED"
          />
        </FilterItem>
      </Filter>

      <Tooltip type={TooltipTypes.bid.ADD} placement="left">
        <Button
          className={classNames(classes.addButton, help.isCurrentStep(TooltipTypes.bid.ADD) && classes.elevate)}
          variant="fab"
          aria-label="add"
          onClick={() => {
            startAddBid({})
              .then((bid) => {
                helpDispatch(TooltipTypes.bid.ADD);
                startEditAdmin({bid: bid});
              })
          }}
        >
          <AddIcon />
        </Button>
      </Tooltip>
    </div>
  );
};

BidsFilter.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  const bidListFilter = state.filters.bidList ? state.filters.bidList : {};

  return({
    bidListFilter,
    help: state.help,
  });
};

const mapDispatchToProps = (dispatch) => ({
  startAddBid: (bid) => dispatch(startAddBid(bid)),
  startEditBidListFilter: (updates) => dispatch(startEditBidListFilter(updates)),
  startEditAdmin: (updates) => dispatch(startEditAdmin(updates)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(BidsFilter);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/BidsFilter.jsx